/**
 * O espectro das etapas — LUMEN.md §4.
 *
 * ONDA W5: isto era um mapa de quatro etapas fixas (`applied` → `decided`) para
 * quatro variáveis CSS. As etapas deixaram de ser um enum: são as do processo
 * que cada VAGA escolheu (migrations 0023/0024), com nomes livres e em número
 * livre. Um mapa por NOME seria impossível de manter — ninguém sabe de antemão
 * que "Triagem técnica" existe.
 *
 * O espectro sobrevive porque nunca dependeu dos nomes: dependia da ORDEM. A cor
 * passa a sair da POSIÇÃO da etapa dentro do seu processo, que é exatamente o
 * que o Kanban já faz nas colunas. Ler a coluna de etapa de uma lista continua a
 * ser ler um espectro, e não decifrar etiquetas cinzentas.
 */

const HUE_INICIAL = 272
const PASSO_POR_POSICAO = 14
const POSICAO_MAXIMA = 6

/**
 * O hue de uma etapa pela sua posição.
 *
 * Do roxo (272) para o azul, um passo por posição, SATURANDO ao fim de seis.
 * Saturar em vez de dividir pelo total é deliberado: numa listagem cada linha
 * pode ser de uma vaga diferente, e portanto de um processo com outro número de
 * etapas — uma cor que mudasse conforme o total faria a mesma "2.ª etapa"
 * aparecer de duas cores em duas linhas seguidas. O Kanban, que mostra um
 * processo de cada vez e conhece o total, interpola de ponta a ponta.
 *
 * Sempre em hues FRIOS: o verde é reservado ao mérito e à marca.
 */
export function stageHue(position: number): number {
  const passo = Math.min(Math.max(position, 0), POSICAO_MAXIMA)
  return HUE_INICIAL - passo * PASSO_POR_POSICAO
}

/**
 * Cor neutra do espectro — para quem ainda não tem etapa.
 *
 * Continua a vir do CSS (e não de um `oklch` literal como a de cima) porque
 * precisa de valores diferentes nos dois temas: no claro tem de descer de
 * luminosidade para ter contraste sobre papel branco.
 */
export const STAGE_COLOR_FALLBACK = 'var(--stage-archived)'

/** A cor de uma etapa pela posição, pronta a usar em `style`. */
export function stageColorByPosition(position: number | null | undefined): string {
  if (position === null || position === undefined) return STAGE_COLOR_FALLBACK
  return `oklch(0.62 0.13 ${stageHue(position)})`
}
